<template>

  <ContentsProductHighPerformancePageTitle title="HIPS (High impact Polystyrene)" />

  <!-- PRODUCT DETAIL PAGE -->
  <section class="section-product-detail-page pb-5 mb-4">
    <div class="container">
      <div class="page-content">

        <div class="properties-applications-box">
          <ContentsTextWithImage
            title="Properties"
            image-url="/pages/products/commodity-plastics/re02.jpg"
            :contents="[
              'HIPS is rigid, translucent, higher impact strength up to 7 times to normal polystyrene'
            ]"
            is-reverse="true"
            left-width="43.444%"
            right-width="56.252%"
          />
          
          <ContentsTextWithImage
            title="Applications"
            image-url="/pages/products/commodity-plastics/yog.jpg"
            credit="photo credit : https://www.conserve-energy-future.com"
            :contents="[
              'Yoghurt cup, refrigerator linings, vending cups, bathroom cabinets, toilet seats and tanks, closures, knobs, trays'
            ]"
            left-width="43.421%"
            right-width="56.275%"
          />
        </div>

      </div>
    </div>
  </section>

  <section class="section-product-detail-page section-our-partners">
    <div class="container">
      <div class="page-content">

        <ContentsOurPartners
          :is-remove-contact-text="true"
          :partners="[
            {
              name: 'IRPC',
              image: {
                width: 245,
                height: 115,
                src: '/pages/products/commodity-plastics/irpc_logo_3.png',
              },
            },
            {
              name: 'Styrolution',
              image: {
                width: 348,
                height: 85,
                src: '/pages/products/commodity-plastics/sty.png',
              },
            },
          ]"
        />

      </div>
    </div>
  </section>

</template>
<script setup>
useHead({
  title: 'hips - NAGASE THAILAND Engineering Plastics',
  meta: [
    {
      rel: 'alternate',
      hreflang: 'en',
      href: `https://group.nagase.com/th/plastics/${process.env.VITE_LANG}/products/commodity-plastics/hips-2`,
    }
  ]
})
</script>

<style scoped>
@media screen and (max-width: 1400px) {
  .container{
    max-width: 1320px;
  }
}

.properties-applications-box {
  display: flex;
  flex-direction: column;
  row-gap: 60px;
}

.section-our-partners .page-content {
  padding: 48px 0 60px;
}
</style>